export default "__VITE_ASSET__CC2JG8Cs__"